import React from "react";
import { Drawer } from "antd";

const GenericDetailsDrawer = ({
  open,
  onClose,
  title = "Details",
  data = {},
  fields = [],
  extraActions,
  emptyValue = "—",
}) => {
  return (
    <Drawer
      title={title}
      placement="right"
      onClose={onClose}
      open={open}
      closable={false}
      headerStyle={{ backgroundColor: '#1565c0' }}
    >
      {fields.map((field, index) => {
        const value = field.render
          ? field.render(data)
          : data?.[field.key];

        if (field.hideIfEmpty && !value) return null;

        return (
          <div
            key={index}
            style={{
              marginBottom: 10,
              display: "flex",
              alignItems: "flex-start",
              gap: 20
            }}
          >
            <div
              style={{
                flex: 2,
                fontWeight: 'bold',
                minWidth: 120
              }}
            >
              {field.label}
            </div>

            <div
              style={{
                flex: 3,
                color: "#666",
                wordBreak: "break-word",
              }}
            >
              {value || emptyValue}
            </div>
          </div>
        );
      })}

      {/* Custom actions (invoice / edit / etc.) */}
      {extraActions && (
        <div style={{ marginTop: 20 }}>
          {extraActions(data)}
        </div>
      )}
    </Drawer>
  );
};

export default GenericDetailsDrawer;